import * as React from 'react';
import { st, classes } from './MobileDrawer.st.css';
import { Modal } from '../internal/Modal';
import { MobileDrawerPosition, } from './types';
/** MobileDrawers provide access to destinations and functionality menus, such as Action Menus, Filter Dropdown etc. This component should be used on mobile only. */
export class MobileDrawer extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            visible: false,
        };
    }
    _onRequestClose() {
        this.setState({ visible: false });
        this.props.onRequestClose();
    }
    componentDidMount() {
        if (this.props.isOpen && !this.state.visible) {
            setTimeout(() => {
                this.setState({ visible: true });
            }, 0);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !this.state.visible) {
            setTimeout(() => {
                this.setState({ visible: true });
            }, 0);
        }
        if (prevProps.isOpen && !this.props.isOpen) {
            this.setState({ visible: false });
        }
    }
    render() {
        const { isOpen, children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, className, position, isFullScreen, } = this.props;
        const { visible } = this.state;
        return (React.createElement("div", { className: st(classes.root, className), "data-hook": this.props['data-hook'] },
            React.createElement(Modal, { isOpen: isOpen, onRequestClose: () => this._onRequestClose() },
                React.createElement("div", { className: st(classes.contentWrapper, {
                        visible,
                        position,
                        fullScreen: isFullScreen,
                    }), role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, children))));
    }
}
MobileDrawer.displayName = 'MobileDrawer';
MobileDrawer.defaultProps = {
    isOpen: false,
    onRequestClose: () => { },
    position: MobileDrawerPosition.Bottom,
    isFullScreen: false,
};
//# sourceMappingURL=MobileDrawer.js.map